export default {
      id: "icon-thermorlion-thicker-usage",
      viewBox: "0 0 67 67",
      url: __webpack_public_path__ + "icons.svg#icon-thermorlion-thicker",
      toString: function () {
        return this.url;
      }
    }